import { CancelledError } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getFaqQueryOptions } from '#widgets/faq'
import { serviceDescriprionQueryOptions } from '#widgets/services-description'

export const Route = createFileRoute('/staff/_post-registration-required/info')({
  loader: async ({ context }) => {
    const { queryClient } = context

    const promiseResults = await Promise.allSettled([
      queryClient.ensureQueryData(getFaqQueryOptions('staff')),
      queryClient.ensureQueryData(serviceDescriprionQueryOptions),
    ])

    for (const promiseResult of promiseResults) {
      if (promiseResult.status === 'rejected') {
        if (promiseResult.reason instanceof CancelledError) continue
        throw promiseResult.reason
      }
    }
  },
})
